export default __webpack_public_path__ + "static/media/Netherlands.dda8dc12.png";